<div class="libro">

  <!-- Sin cabecera no se sabe si la matriz maneja activos: se avisa en vez
       de comportarse en silencio como la matriz de IA. -->
  <div class="libro-aviso-error" *ngIf="errorMatriz">{{ errorMatriz }}</div>

  <div class="libro-head">
    <div>
      <!-- El titulo del formato y la organizacion se editan en Hojas de
           Apoyo; el nombre y el alcance, con Editar (29/09/2026). -->
      <h2>{{ formato.titulo }} &mdash; {{ tituloMatriz }}</h2>
      <p class="libro-sub">
        {{ matriz?.alcance || '—' }} &middot; {{ formato.organizacion }}
      </p>
      <!-- Version y liberacion DEL FORMATO, como en el encabezado del Excel.
           No confundir con la version del documento, que va en la ficha. -->
      <p class="libro-formato">
        <span>Formato <b>V {{ formato.version }}</b></span>
        <span class="libro-formato-sep">&middot;</span>
        <span>Liberado el <b>{{ formatoLiberacion }}</b></span>
      </p>
    </div>
    <div class="libro-acciones">
      <!-- Se llega aquí desde el tablero de Gestión de Riesgos y desde el menú
           lateral; en los dos casos conviene una salida a la vista, sin tener
           que buscar la entrada del menú otra vez. -->
      <button type="button" class="libro-btn-volver" (click)="volverAlTablero()"
              matTooltip="Regresar al tablero con todas las matrices">
        &larr; Gestión de Riesgos
      </button>
      <!-- Lo que antes se editaba desde la tarjeta del tablero (29/09/2026):
           nombre, área, alcance, proceso y si trabaja con activos. -->
      <button type="button" class="libro-btn-guia libro-btn-editar" (click)="editarMatriz()"
              *ngIf="matriz && puedeAdministrar"
              matTooltip="Nombre, área, alcance, proceso y si trabaja con activos">
        <span class="material-icons" aria-hidden="true">edit</span>
        Editar
      </button>
      <!-- Control de cambios de la MATRIZ (lo guardado que espera que alguien
           lo acepte), no confundir con «Historial de cambios», que son las
           versiones del documento. Sólo para el perfil de edición, y sólo si
           el control está encendido o quedó alguna pendiente. -->
      <button type="button" class="libro-btn-cambios" (click)="abrirCambiosPorAprobar()"
              *ngIf="puedeEditar && (aprobacionActiva || pendientesMatriz > 0)"
              matTooltip="Lo que se guardó en esta matriz y espera que alguien lo acepte o lo descarte">
        Cambios por aprobar
        <span class="libro-btn-n">{{ pendientesMatriz }}</span>
      </button>
      <!-- El historial sí se captura, a diferencia de los criterios: por eso
           lleva color propio y va antes, separado de la consulta. -->
      <button type="button" class="libro-btn-historial" (click)="abrirHistorial()"
              matTooltip="Versiones del documento: registrar una nueva o corregir una existente">
        Historial de cambios
        <span class="libro-btn-n" *ngIf="versiones.length">{{ versiones.length }}</span>
      </button>
      <!-- Un solo botón para las tres hojas de apoyo del Excel: no se capturan,
           se consultan, y adentro se cambia de una a otra. Se llama "Hojas de
           apoyo" y no "Criterios" para no confundirse con el botón de Criterios
           de evaluación de Plan Gestión RSK, que muestra otra cosa: las escalas
           de probabilidad, impacto y severidad. -->
      <button type="button" class="libro-btn-guia" (click)="abrirAyudas()"
              matTooltip="Estrategias de respuesta, catálogo de amenazas y apreciación de riesgos">
        Hojas de apoyo
      </button>
      <button mat-flat-button color="primary" (click)="exportar()" [disabled]="exportando"
              matTooltip="Descarga el libro completo con una hoja por cada pestaña">
        {{ exportando ? 'Generando…' : 'Exportar a Excel' }}
      </button>
    </div>
  </div>

  <mat-tab-group animationDuration="0ms" class="libro-tabs" [(selectedIndex)]="pestana">

    <!-- ============ 1. GENERAL ============ -->
    <mat-tab label="General">
      <div class="hoja">
        <!--
          La ficha venía de la pestaña "Menú", que se quitó por no usarse: el
          índice que traía lo dan las pestañas, pero la identificación del
          documento y la versión vigente sí hacen falta para certificación,
          y aquí quedan justo arriba del historial de versiones.
        -->
        <h3>Identificación del documento</h3>

        <div class="ficha-card">
          <div class="ficha-grid">
            <div class="ficha-campo">
              <div class="ficha-et">Formato</div>
              <div>{{ formato.titulo }}</div>
            </div>
            <div class="ficha-campo">
              <div class="ficha-et">Área</div>
              <div>{{ matriz?.areaNombre || 'Sin área' }}</div>
            </div>
            <div class="ficha-campo">
              <div class="ficha-et">Proceso</div>
              <div>{{ matriz?.proceso || 'Administración de Riesgos' }}</div>
            </div>
            <div class="ficha-campo">
              <div class="ficha-et">Alcance</div>
              <div>{{ matriz?.alcance || '—' }}</div>
            </div>
            <div class="ficha-campo">
              <div class="ficha-et">Versión vigente</div>
              <div class="ficha-version">
                <span class="ficha-vchip">
                  {{ versiones.length ? versiones[versiones.length - 1].version : '—' }}
                </span>
                <span *ngIf="versiones.length" class="ficha-vfecha">
                  del {{ versiones[versiones.length - 1].fechaVersion | date: 'dd/MM/yyyy' }}
                </span>
              </div>
            </div>
            <div class="ficha-campo total">
              <div class="ficha-et">Metodología</div>
              <!-- Tiene que decir lo mismo que el Excel del mismo documento
                   (MatrizExcelBuss), que ya se adapta segun aplica_activos. -->
              <div>{{ metodologia }}</div>
            </div>
          </div>
        </div>

        <!-- ===== Resumen: en qué vamos, de un vistazo ===== -->
        <h3>Planes de gestión &mdash; riesgos de proceso</h3>

        <div class="res-tot">
          <span class="res-t"><b>{{ riesgos.length }}</b> riesgos</span>
          <span class="res-t alerta" *ngIf="pendientesRsk > 0">
            <b>{{ pendientesRsk }}</b> corte(s) sin resultado
          </span>
          <span class="res-t ok" *ngIf="pendientesRsk === 0 && riesgos.length > 0">Monitoreo al día</span>
          <!-- Sin riesgos no hay nada que estar "al dia": decirlo seria dar por
               bueno un documento vacio. -->
          <span class="res-t" *ngIf="riesgos.length === 0">Todavía sin riesgos capturados</span>
        </div>

        <div class="res-caja">
          <table class="res-tabla">
            <thead>
              <tr>
                <th>Folio</th>
                <th>Riesgo</th>
                <th>Estrategia</th>
                <th class="c">Al detectarlo</th>
                <th class="c">Tras el plan</th>
                <th class="c">Monitoreo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of riesgos" class="res-fila"
                  (click)="irARiesgo(r)" (keydown.enter)="irARiesgo(r)"
                  tabindex="0" role="button"
                  [title]="'Ver ' + r.consecutivo + ' en Plan Gestión RSK'">
                <td><span class="res-folio">{{ r.consecutivo }}</span></td>
                <td class="res-desc">
                  {{ r.descripcion }}
                  <span class="res-estado" *ngIf="r.estatus === 'ACTIVO'">En seguimiento</span>
                </td>
                <td><span class="res-tag" *ngIf="r.estrategia">{{ r.estrategia }}</span></td>
                <td class="c">
                  <span class="res-n" [ngClass]="claseSeveridad(r.clasificacionInicial)">
                    {{ r.severidadInicial ?? '—' }}
                  </span>
                  <span class="res-banda">{{ etiquetaBanda(r.clasificacionInicial) }}</span>
                </td>
                <td class="c">
                  <span class="res-n" [ngClass]="claseSeveridad(r.clasificacionReevaluada)">
                    {{ r.severidadReevaluada ?? '—' }}
                  </span>
                  <span class="res-banda">{{ etiquetaBanda(r.clasificacionReevaluada) }}</span>
                </td>
                <td class="c">
                  {{ cortesRiesgo(r) }} corte(s)
                  <span class="res-falta" *ngIf="pendientesRiesgo(r) > 0">
                    {{ pendientesRiesgo(r) }} sin resultado
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      <!-- El resumen de activos solo tiene sentido en las matrices que los
           usan (TI/IA); las demas areas trabajan con riesgos de proceso. -->
      <ng-container *ngIf="conActivos">
        <h3>Activos</h3>

        <div class="res-tot">
          <span class="res-t"><b>{{ activos.length }}</b> activos</span>
          <span class="res-t alerta" *ngIf="activosEnAlto > 0">
            <b>{{ activosEnAlto }}</b> en riesgo alto o muy alto
          </span>
          <span class="res-t"><b>{{ accionesProgramadas }}</b> acción(es) por aplicar</span>
        </div>

        <div class="res-caja">
          <table class="res-tabla">
            <thead>
              <tr>
                <th>Folio</th>
                <th>Activo</th>
                <th class="c">Valor</th>
                <th class="c">Riesgo actual</th>
                <th class="c">Tras el plan</th>
                <th class="c">Amenazas</th>
                <th class="c">Plan</th>
                <th class="c">Monitoreo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let a of activos" class="res-fila"
                  (click)="irAActivo(a)" (keydown.enter)="irAActivo(a)"
                  tabindex="0" role="button"
                  [title]="'Ver ' + a.consecutivo + ' en Activos'">
                <td><span class="res-folio">{{ a.consecutivo }}</span></td>
                <td class="res-desc">
                  <b>{{ a.nombreActivo }}</b>
                  <span class="res-inv" *ngIf="a.inventarioConsecutivo">
                    {{ a.inventarioConsecutivo }}
                  </span>
                  <span class="res-inv" *ngIf="a.solicitudFolio"
                        [title]="'Entró a la matriz al autorizarse la solicitud ' + a.solicitudFolio + ' en Solicitudes IA.'">
                    Viene de la solicitud {{ a.solicitudFolio }}
                  </span>
                </td>
                <td class="c">{{ a.valorActivo ?? '—' }}</td>
                <td class="c">
                  <span class="res-n" [ngClass]="claseNivel(a.riesgoActual ?? null)">
                    {{ a.riesgoActual ?? '—' }}
                  </span>
                  <span class="res-banda">{{ a.clasificacionActual }}</span>
                </td>
                <td class="c">
                  <span class="res-n" [ngClass]="claseNivel(a.riesgoResidual ?? null)">
                    {{ a.riesgoResidual ?? '—' }}
                  </span>
                  <span class="res-banda">{{ a.clasificacionResidual }}</span>
                </td>
                <td class="c">{{ amenazasDelActivo(a) }}</td>
                <td class="c">
                  {{ accionesDe(a) }}
                  <span class="res-falta" *ngIf="programadasDe(a) > 0">
                    {{ programadasDe(a) }} por aplicar
                  </span>
                </td>
                <td class="c">{{ cortesDe(a) }} corte(s)</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      </div>
    </mat-tab>

    <!-- ============ 2. PLAN GESTIÓN RSK ============ -->
    <mat-tab label="Plan Gestión RSK">
      <div class="hoja">
        <app-rsk-completo-ia [idMatriz]="idMatriz" [conActivos]="conActivos"
                             [matriz]="matriz"></app-rsk-completo-ia>
      </div>
    </mat-tab>

    

    <!-- ============ 4. ACTIVOS ============
         Sólo para las matrices que trabajan con activos (TI/IA). Las demás
         áreas gestionan sus riesgos de proceso y no tienen inventario. -->
    <mat-tab label="Activos" *ngIf="conActivos">
      <div class="hoja">
        <!-- Una tarjeta por activo. Absorbe el seguimiento y el alta/baja, que
             antes vivían en dos listados aparte debajo de la matriz. -->
        <app-matriz-completa-ia [idMatriz]="idMatriz"></app-matriz-completa-ia>
      </div>
    </mat-tab>

    

    

  </mat-tab-group>

  <!-- ==================== Ventana de criterios ====================
       Estas tres hojas no se capturan nunca: son la referencia con la que se
       llenan las otras. Se abren desde el encabezado y el nodo se cuelga de
       <body> (ver moverVentana en el TS). -->
  <div class="ay" #ventanaAyudas [class.abierta]="ayudas">
    <div class="ay-fondo" (click)="cerrarAyudas()" (keydown.enter)="cerrarAyudas()"></div>

    <div class="ay-caja" role="dialog" aria-modal="true" aria-label="Hojas de apoyo del formato">
      <div class="ay-cab">
        <div>
          <strong>Hojas de apoyo del formato</strong>
          <span class="ay-sub">
            Estrategias, catálogo de amenazas y apreciación de riesgos. La referencia con la
            que se llenan las hojas: aquí no se captura nada.
          </span>
        </div>
        <button type="button" class="ay-cerrar" (click)="cerrarAyudas()">✕ Cerrar</button>
      </div>

      <div class="ay-nav">
        <button type="button" *ngFor="let s of secciones" class="ay-pestana"
                [class.activa]="seccionAyuda === s.clave" (click)="seccionAyuda = s.clave">
          <span class="ay-pestana-tit">{{ s.titulo }}</span>
          <span class="ay-pestana-pie">{{ s.pie }}</span>
        </button>
      </div>

      <div class="ay-cuerpo">
        <div class="hoja" *ngIf="seccionAyuda === 'estrategias'">
          <!-- La introduccion de la hoja del Excel: que es un riesgo. -->
          <div class="ay-tarjeta exl-caja est-intro-caja">
            <div class="exl-cab">{{ introTitulo() }}</div>
            <p class="est-texto est-intro">{{ introCuerpo() }}</p>
          </div>

          <h3>Estrategias de respuesta al riesgo</h3>
          <div class="est-card" *ngFor="let e of estrategiasVigentes()">
            <div class="est-cab" [ngClass]="claseEstrategia(e.nombre)">
              <span class="est-nombre">{{ e.nombre }}</span>
            </div>
            <p class="est-texto">{{ e.descripcion || '—' }}</p>
          </div>
          <p class="vacio" *ngIf="estrategiasVigentes().length === 0">Catálogo de estrategias vacío.</p>

          <div class="exl-cab exl-titulo exl-sep" *ngIf="apoyoActivo('TIT_CRIT_PROB')">{{ apoyoTextoDe('TIT_CRIT_PROB', 'Criterios para la evaluación del riesgo') }}</div>
          <div class="ay-tarjeta"><table class="tabla">
            <thead><tr><th>Descripción</th><th class="w-corta c">Probabilidad</th><th class="w-mini c">Nivel</th></tr></thead>
            <tbody>
              <tr *ngFor="let s of severidadDesc('PROBABILIDAD')">
                <td class="td-pre c">{{ s.descripcion }}</td>
                <td class="c nw"><strong>{{ s.etiqueta }}</strong></td>
                <td class="c"><strong>{{ s.nivel }}</strong></td>
              </tr>
            </tbody>
          </table></div>

          <div class="exl-cab exl-titulo exl-sep" *ngIf="apoyoActivo('TIT_CRIT_IMPACTO')">{{ apoyoTextoDe('TIT_CRIT_IMPACTO', 'Categorías de Impacto') }}</div>
          <div class="ay-tarjeta"><table class="tabla">
            <thead><tr>
              <th class="w-media">Propósito / dirección estratégica / objetivos</th>
              <th>Partes interesadas</th>
              <th class="w-corta c">Categoría de Impacto</th>
              <th class="w-mini c">Nivel</th>
            </tr></thead>
            <tbody>
              <tr *ngFor="let s of severidadDesc('IMPACTO')">
                <td class="td-pre c">{{ s.proposito }}</td>
                <td class="td-pre">{{ s.descripcion }}</td>
                <td class="c nw"><strong>{{ s.etiqueta }}</strong></td>
                <td class="c"><strong>{{ s.nivel }}</strong></td>
              </tr>
            </tbody>
          </table></div>

          <div class="exl-cab exl-titulo exl-sep" *ngIf="apoyoActivo('TIT_CRIT_EVAL')">{{ apoyoTextoDe('TIT_CRIT_EVAL', 'Criterios para Evaluación de Riesgos') }}</div>
          <div class="cri3">
            <div class="ay-tarjeta cri3-caja">
              <div class="cri3-def" *ngIf="apoyoActivo('DEF_CRIT_PROB')">{{ apoyoTextoDe('DEF_CRIT_PROB', notas['criterioProbabilidad']) }}</div>
              <!-- Encabezado sólo para lectores de pantalla: a la vista lo da la definición de arriba. -->
              <table class="tabla"><thead class="cdk-visually-hidden"><tr><th scope="col">Probabilidad</th><th scope="col">Nivel</th></tr></thead><tbody>
                <tr *ngFor="let s of severidadPor('PROBABILIDAD')">
                  <td>{{ s.etiqueta }}</td>
                  <td class="c w-mini"><strong>{{ s.nivel }}</strong></td>
                </tr>
              </tbody></table>
            </div>
            <div class="ay-tarjeta cri3-caja">
              <div class="cri3-def" *ngIf="apoyoActivo('DEF_CRIT_IMPACTO')">{{ apoyoTextoDe('DEF_CRIT_IMPACTO', notas['criterioImpacto']) }}</div>
              <!-- Encabezado sólo para lectores de pantalla: a la vista lo da la definición de arriba. -->
              <table class="tabla"><thead class="cdk-visually-hidden"><tr><th scope="col">Impacto</th><th scope="col">Nivel</th></tr></thead><tbody>
                <tr *ngFor="let s of severidadPor('IMPACTO')">
                  <td>{{ s.etiqueta }}</td>
                  <td class="c w-mini"><strong>{{ s.nivel }}</strong></td>
                </tr>
              </tbody></table>
            </div>
            <div class="ay-tarjeta cri3-caja ancha">
              <table class="tabla">
                <thead><tr>
                  <th class="c">Severidad Riesgo</th>
                  <th class="c">Probabilidad &times; Impacto</th>
                  <th>Criterios de Aceptación del Riesgo según Severidad del Riesgo</th>
                </tr></thead>
                <tbody>
                  <tr *ngFor="let c of clasSeveridad">
                    <td class="c nw"><strong>{{ c.clasificacion }}</strong></td>
                    <td class="c nw">{{ c.nivelDesde }} a {{ c.nivelHasta }}</td>
                    <td class="td-largo" [ngClass]="claseFilaSev(c.clasificacion)">{{ c.criterioAceptacion }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="hoja" *ngIf="seccionAyuda === 'amenazas'">
          <h3>Catálogo de amenazas</h3>
          <p class="hoja-nota">
            Sirve para clasificar cada amenaza propia en una categoría reconocida. Se elige en la
            pantalla de edición del activo, en el campo <em>Categoría del catálogo</em>.
          </p>

          <div *ngFor="let cat of categoriasAmenaza" class="grupo-amenaza"
               [ngClass]="claseCategoria(cat)">
            <div class="ga-cab">
              <span>{{ cat }}</span>
              <span class="ga-n">{{ amenazasDe(cat).length }}</span>
            </div>
            <p class="cat-desc" *ngIf="descripcionCategoria(cat)">{{ descripcionCategoria(cat) }}</p>
            <ul class="lista-amenazas">
              <li *ngFor="let a of amenazasDe(cat)">{{ a.nombre }}</li>
            </ul>
          </div>

        </div>

        <div class="hoja" *ngIf="seccionAyuda === 'apreciacion'">
          <!-- Las cuatro secciones de la hoja del Excel, como páginas. -->
          <div class="exl-subnav">
            <button type="button" *ngFor="let s of seccionesApre" class="exl-subtab"
                    [class.activa]="seccionApre === s.clave"
                    (click)="seccionApre = s.clave">{{ s.titulo }}</button>
          </div>

          <ng-container *ngIf="seccionApre === 'valoracion'">

          <!-- Cabecera de la hoja del Excel: que puede ser un activo y como
               se clasifica. Mismo contenido fijo que la pantalla de gestion. -->
          <div class="exl-intro">
            <div class="ay-tarjeta exl-caja">
              <div class="exl-cab" *ngIf="apoyoActivo('TIT_APRE_ACTIVOS')">{{ apoyoTextoDe('TIT_APRE_ACTIVOS', 'Los activos pueden ser') }}</div>
              <ul class="exl-lista">
                <li *ngFor="let a of apoyoDe('ACTIVOS_PUEDEN_SER')">{{ a }}</li>
              </ul>
            </div>
            <div class="ay-tarjeta exl-caja">
              <div class="exl-cab" *ngIf="apoyoActivo('TIT_APRE_CLASIF')">{{ apoyoTextoDe('TIT_APRE_CLASIF', 'Clasificación de Activos') }}</div>
              <div class="exl-clasif">
                <div>
                  <h5>Hardware</h5>
                  <ul><li *ngFor="let x of apoyoDe('CLASIF_HARDWARE')">{{ x }}</li></ul>
                </div>
                <div>
                  <h5>Software</h5>
                  <ul><li *ngFor="let x of apoyoDe('CLASIF_SOFTWARE')">{{ x }}</li></ul>
                </div>
              </div>
            </div>
          </div>

          <div class="exl-cab exl-titulo" *ngIf="apoyoActivo('TIT_APRE_VAL')">{{ apoyoTextoDe('TIT_APRE_VAL', 'Valoración de Activos') }}</div>

          <!-- En el orden de la hoja del Excel. -->
          <div *ngFor="let dim of ['DISPONIBILIDAD','INTEGRIDAD','CONFIDENCIALIDAD']">
            <h4 class="nota" [title]="notaDimension(dim)">{{ dim | titlecase }}</h4>
            <div class="exl-def" *ngIf="apoyoActivo(listaDimension(dim))">{{ apoyoTextoDe(listaDimension(dim), definicionDimension(dim)) }}</div>
            <div class="ay-tarjeta"><table class="tabla">
              <thead><tr><th class="w-mini c">Nivel</th><th class="w-corta">Etiqueta</th><th>Criterio</th></tr></thead>
              <tbody>
                <tr *ngFor="let v of valoracionPor(dim)">
                  <td class="c"><strong>{{ v.nivel }}</strong></td>
                  <td>{{ v.etiqueta }}</td>
                  <td class="td-largo">{{ v.descripcion }}</td>
                </tr>
              </tbody>
            </table></div>
          </div>
          </ng-container>

          <ng-container *ngIf="seccionApre === 'valoracion'">
          <div class="exl-cab exl-titulo exl-sep" *ngIf="apoyoActivo('TIT_APRE_AME')">{{ apoyoTextoDe('TIT_APRE_AME', 'Identificación y valoración de amenazas') }}</div>
          <div class="exl-def" *ngIf="apoyoActivo('DEF_APRE_AME')">{{ apoyoTextoDe('DEF_APRE_AME', 'Amenaza. ' + definicion('nombreAmenaza')) }}</div>
          <div class="exl-def suave" *ngIf="apoyoActivo('DEF_APRE_PROB_AME')">{{ apoyoTextoDe('DEF_APRE_PROB_AME', definicion('probAmenaza')) }}</div>
          <div class="ay-tarjeta"><table class="tabla">
            <thead><tr><th class="w-mini c">Nivel</th><th class="w-corta">Etiqueta</th><th>Frecuencia anual</th></tr></thead>
            <tbody>
              <tr *ngFor="let p of probabilidadPor('AMENAZA')">
                <td class="c"><strong>{{ p.nivel }}</strong></td>
                <td class="nw">{{ p.etiqueta }}</td>
                <td class="td-largo">{{ p.descripcion }}</td>
              </tr>
            </tbody>
          </table></div>
          </ng-container>

          <ng-container *ngIf="seccionApre === 'valoracion'">
          <div class="exl-cab exl-titulo exl-sep" *ngIf="apoyoActivo('TIT_APRE_VUL')">{{ apoyoTextoDe('TIT_APRE_VUL', 'Determinación de las vulnerabilidades del sistema y su relación con las amenazas') }}</div>
          <div class="exl-def" *ngIf="apoyoActivo('DEF_APRE_VUL')">{{ apoyoTextoDe('DEF_APRE_VUL', definicion('vulnerabilidad')) }}</div>
          <div class="exl-def suave" *ngIf="apoyoActivo('DEF_APRE_PROB_VUL')">{{ apoyoTextoDe('DEF_APRE_PROB_VUL', definicion('probVulnerabilidad')) }}</div>
          <div class="ay-tarjeta"><table class="tabla">
            <thead><tr><th class="w-mini c">Nivel</th><th class="w-corta">Etiqueta</th><th>Probabilidad (peor escenario)</th></tr></thead>
            <tbody>
              <tr *ngFor="let p of probabilidadPor('VULNERABILIDAD')">
                <td class="c"><strong>{{ p.nivel }}</strong></td>
                <td class="nw">{{ p.etiqueta }}</td>
                <td class="td-largo">{{ p.descripcion }}</td>
              </tr>
            </tbody>
          </table></div>
          </ng-container>

          <ng-container *ngIf="seccionApre === 'riesgo'">
          <div class="exl-cab exl-titulo exl-sep nota" [title]="notas['nivelRiesgoActivo']"
               *ngIf="apoyoActivo('TIT_APRE_RIESGO')">{{ apoyoTextoDe('TIT_APRE_RIESGO', 'Valoración del Riesgo — riesgo actual (intrínseco) / riesgo tras plan de acción (residual)') }}</div>
          <p class="hoja-nota">
            Es el criterio con el que el módulo calcula el riesgo: se cruza el valor del activo con
            el nivel de amenaza y el de vulnerabilidad. <strong>Estas 96 combinaciones son datos</strong>,
            no fórmulas: se pueden ajustar sin tocar el sistema.
          </p>

          <div class="ay-tarjeta ancha"><div class="scroll-x">
            <table class="tabla matriz-valoracion">
              <thead>
                <tr>
                  <th rowspan="2" class="c w-corta">Valor<br>activo</th>
                  <th *ngFor="let a of niveles" [attr.colspan]="4" class="c th-amz gsep">Amenaza {{ etiquetasNivel[a - 1] }}</th>
                </tr>
                <tr>
                  <ng-container *ngFor="let a of niveles">
                    <th *ngFor="let v of niveles" class="c w-mini th-vul" [class.gsep]="v === 1"
                        [title]="'Vulnerabilidad ' + etiquetasNivel[v - 1]">{{ inicialesNivel[v - 1] }}</th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let val of valoresActivo">
                  <td class="c"><strong>{{ val }}</strong></td>
                  <ng-container *ngFor="let a of niveles">
                    <td *ngFor="let v of niveles" class="c num96" [class.gsep]="v === 1"
                        [ngClass]="'gama-' + a">
                      <strong>{{ celda(val, a, v) }}</strong>
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div></div>

          <div class="exl-cab exl-titulo exl-sep" *ngIf="apoyoActivo('TIT_APRE_CRIT')">{{ apoyoTextoDe('TIT_APRE_CRIT', 'Criterio de aceptación del riesgo') }}</div>
          <div class="ay-tarjeta"><table class="tabla crit-acept">
            <thead>
              <tr>
                <th class="c th-nivel w-media">Nivel (Valor) del Riesgo</th>
                <th class="c th-desc">DESCRIPCIÓN</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of clasificaciones">
                <td class="c nw" [ngClass]="tintaBanda(c.clasificacion)">
                  <strong>{{ c.nivelDesde }}-{{ c.nivelHasta }} {{ c.clasificacion }}</strong>
                </td>
                <td class="td-pre" [ngClass]="tintaBanda(c.clasificacion)">{{ c.criterioAceptacion }}</td>
              </tr>
            </tbody>
          </table></div>
          </ng-container>


        </div>
      </div>
    </div>
  </div>

  <!-- ==================== Ventana del historial ====================
       A diferencia de los criterios, aquí sí se captura: por eso no cierra
       con Escape ni con clic en el fondo, solo con su botón. -->
  <div class="ay hist" #ventanaHistorial [class.abierta]="historial">
    <div class="ay-fondo"></div>

    <div class="ay-caja" role="dialog" aria-modal="true" aria-label="Historial de cambios">
      <div class="ay-cab">
        <div>
          <strong>Historial de cambios</strong>
          <span class="ay-sub">
            Cada modificación del documento con quién la elaboró y quién la autorizó.
            Aquí se registra una versión nueva o se corrige una existente.
          </span>
        </div>
        <button type="button" class="ay-cerrar" (click)="cerrarHistorial()">✕ Cerrar</button>
      </div>

      <div class="ay-cuerpo">
        <app-control-cambios-ia [idMatriz]="idMatriz" (cambio)="cargarVersiones()"></app-control-cambios-ia>
      </div>
    </div>
  </div>

</div>
